import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { AvatarWithLabel, DialogContent, DialogFooter, DialogHeader, GridCell } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { CancelButton, FormDialog, SubmitButton, TextField } from 'shared/domains/forms';
import { PhoneNumberField } from 'shared/domains/forms/components/PhoneNumberField';
import { PublicField } from './PublicField';
import { Rejections } from './Rejections';
import { formatValues, getValidationSchema } from './utils';
import { AuthenticationModeSelect } from '../../EsigningSidebar/RecipientModal/Content/RoleAndAuth/AuthenticationModeSelect';
import { Grid } from './styled';
export function ContactForm(props) {
    const { initialValues, onClose, onSubmit, rejections } = props;
    const validationSchema = getValidationSchema();
    const formattedInitialValues = formatValues(initialValues);
    const isEdit = Boolean(initialValues);
    const addTitle = t({
        message: 'Add contact',
        comment: 'Esigning contacts form - Add contact title',
    });
    const editTitle = t({
        message: 'Edit contact',
        comment: 'Esigning contacts form - Edit contact title',
    });
    const headerTitle = isEdit ? editTitle : addTitle;
    const submitLabel = isEdit
        ? t({ message: 'Update', comment: 'Esigning contacts form - Update button label' })
        : t({ message: 'Save', comment: 'Esigning contacts form - Save button label' });
    return (<FormDialog onClose={onClose} initialValues={formattedInitialValues} onSubmit={onSubmit} validationSchema={validationSchema}>
      <DialogHeader title={<AvatarWithLabel size="md" shape="square" appearance="light" title={headerTitle}>
            <Falcon icon="user"/>
          </AvatarWithLabel>}/>
      <DialogContent>
        <Rejections rejections={rejections}/>

        <Grid>
          <GridCell width={{ base: 2, md: 1 }}>
            <TextField name="firstName" label={t({ message: 'First name', comment: 'Esigning contacts form' })}/>
          </GridCell>
          <GridCell width={{ base: 2, md: 1 }}>
            <TextField name="lastName" label={t({ message: 'Last name', comment: 'Esigning contacts form' })}/>
          </GridCell>

          <GridCell width={{ base: 2, md: 1 }}>
            <TextField name="title" label={t({ message: 'Title', comment: 'Esigning contacts form' })}/>
          </GridCell>
          <GridCell width={{ base: 2, md: 1 }}>
            <TextField name="label" label={t({ message: 'Company', comment: 'Esigning contacts form' })}/>
          </GridCell>
        </Grid>

        <Grid>
          <GridCell width={{ base: 12 }}>
            <TextField name="email" label={t({ message: 'E-mail', comment: 'Esigning contacts form' })}/>
          </GridCell>

          <GridCell width={{ base: 12 }}>
            <AuthenticationModeSelect />
          </GridCell>

          <GridCell width={{ base: 12 }}>
            <PhoneNumberField stretch name="mobile" label={t({
            comment: 'Signing party form field - Phone number',
            message: 'Phone number',
        })}/>
          </GridCell>

          <GridCell width={{ base: 12 }}>
            <PublicField disabled={isEdit}/>
          </GridCell>
        </Grid>
      </DialogContent>

      <DialogFooter>
        <CancelButton size="small" onClick={onClose}>
          <Trans comment="Esigning contacts form - Cancel button label">Cancel</Trans>
        </CancelButton>
        <SubmitButton size="small">{submitLabel}</SubmitButton>
      </DialogFooter>
    </FormDialog>);
}
